import { Sentry } from "./sentryInstrument";


function sanitizeSECode(rawSECode) {
  if (typeof rawSECode !== "string") {
    return null;
  }

  const seCode = rawSECode.trim().toUpperCase();
  if (!seCode) {
    return null;
  }

  // Keep this lightweight: only allow the same basic shape as backend codes.
  if (!/^[AR][0-9A-Z]+$/.test(seCode)) {
    return null;
  }

  // Backend formats are short (e.g. AZZ..., RYY..), so reject unusually long input.
  if (seCode.length < 3 || seCode.length > 10) {
    return null;
  }

  return seCode;
}

async function setSECodeCookie(endpoint, retriesLeft) {
  const currentParams = new URLSearchParams(document.location.search);
  const url = new URL(endpoint);
  if (!currentParams.has("se")) {
	return;
  }
  const sanitizedSECode = sanitizeSECode(currentParams.get("se"));
  if (!sanitizedSECode) {
    return;
  }
  url.searchParams.append("se", sanitizedSECode);
  url.searchParams.append("seref", document.referrer);

  try {
		const response = await fetch(url.toString());
		if (!response.ok) {
			throw new Error(`Unexpected ${response.statusText} response ${response.status} from ${url}`);
		}
  } catch (error) {
		if (retriesLeft > 0) {
			await new Promise(r => setTimeout(r, 2000));	// NOTE: sleep 2 seconds
			await setSECodeCookie(url, retriesLeft - 1);
		} else {
			if (Sentry && Sentry.captureException) {
				Sentry.captureException(error);
			}
		}
  }
}

window.addEventListener("DOMContentLoaded", () => {
  if (window.setSECodeURL) {
	// Add .catch() to prevent unhandled promise rejection
	setSECodeCookie(window.setSECodeURL, 4).catch(error => {
		if (Sentry && Sentry.captureException) {
			Sentry.captureException(error);
		} else {
			console.error("Error setting SE code cookie", error);
		}
	});
  }
});
